var map = {
	"./background.jpeg": "c8f5",
	"./book.png": "3784",
	"./bulletin-board.png": "08ac",
	"./classroom.png": "ef71",
	"./home_background.jpg": "f7db",
	"./key.png": "b738",
	"./megaphone.png": "3513",
	"./online-lesson.png": "0ba1",
	"./receipt.png": "8a81",
	"./report-card.png": "21d5",
	"./schedule.png": "4a85",
	"./school.png": "41be",
	"./settings.png": "d96e",
	"./student.png": "f070",
	"./team.png": "c4c1",
	"./user.png": "0f71",
	"./warn.png": "c7ac"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "bb6e";